function after_cf_submit(form){
    if(dataLayer){
        dataLayer.push({'event': 'form_sent'});
    }
}
